import React, { useEffect, useState } from "react"
// MUI
import {Button, CircularProgress, Grid, TextField, Typography} from "@mui/material"
import DownloadIcon from '@mui/icons-material/Download'
// style
import {style} from "./style"
// API
import { APIGetBlobCustomHeader } from "../../api/apiCalls"
import {returnQRCodeParameters} from "../../utils/parsingFunctions";
import {downloadBlob} from "../../utils/fileFunctions";

export default function QRCodeDocument(props: any) {
    const {password, upload_id} = props.fieldDisplay;

    const [pwd, setPwd] = useState<string>("");
    // display switch
    const [passwordProtected, setPasswordProtected] = useState<any>(null);
    const [passwordError, setPasswordError] = useState<any>(null);

    const {resAddr, type, id} = returnQRCodeParameters()

    useEffect(() => {

        console.log("PROPS: ", props)
        // downloadContent();
        // if (allow_download) setDownload(allow_download);
    }, [props.fieldDisplay])

    useEffect(() => {
        if (!!password) {
            console.log("password detected")
            setPasswordProtected(true)
        } else if (!!upload_id) {
            console.log("no password: ", upload_id)
            setPasswordProtected(false)
            // TODO: open document
            downloadContent()
            // window.open("https://media.hosting.sandbox.unitag.io/" + upload_id, "_blank")
        }
    }, [password]);

    const handleChange = (event: any) => {
        setPwd(event.target.value)
    }

    const downloadContent = () => {
        const headers: Record<string, string> = {
            "X-Media-Password": pwd
        }

        APIGetBlobCustomHeader(`${resAddr}/${type}/${id}/download`, headers)
            .then((data: any) => {
                if (data.ok && data.rawBlob) {
                    setPasswordError(false)
                    let blob: any = data.rawBlob;
                    blob = new Blob([blob], { type: data.rawBlob.type })

                    let url = URL.createObjectURL(blob)
                    window.open(url)
                } else {
                    setPasswordError(true)
                }
            })
            .catch((err: Error) => {
                console.log(err);
                setPasswordError(true)
            })
    }

    return (
        <Grid item container xs={12} justifyContent={'center'}>
            {passwordProtected === null && <CircularProgress />}

            {!!passwordProtected &&
                <>
                    <Grid xs={12}>
                        <TextField
                            id="password"
                            label="Password"
                            type="password"
                            fullWidth
                            sx={{ mt: 3 }}
                            value={pwd}
                            onChange={handleChange}
                        />
                    </Grid>
                    {
                        passwordError && (
                            <Grid item xs={12}>
                                <Typography variant="body2" color="error">
                                    Error with your password. Please try again.
                                </Typography>
                            </Grid>
                        )
                    }
                    <Grid xs={12} >
                        <Button
                            onClick={downloadContent}
                            variant="contained"
                            fullWidth
                            size={"large"}
                            disableElevation
                        >
                            Validate password
                        </Button>
                    </Grid>
                </>
            }
        </Grid>
    );
}
